import React from 'react';
import styles from './Avatar.module.scss';
import cx from 'classnames';
import Helper from '../../utils/Helper';
import { parseString } from '../../utils/stringHelper';

const Avatar = ({ alt = '', children, className, image, title, oneLetterAcronym = true, size = 'medium' }) => {
  const getNameFirstLetter = username => {
    if (username) {
      const parsedName = parseString(username);
      return parsedName[0]?.toUpperCase();
    }
    return '';
  };

  return (
    <div
      className={cx(
        styles.container,
        styles[size],
        {
          [styles.labled]: !Boolean(image),
        },
        className
      )}
    >
      {image ? (
        <img className={styles.imageIcon} src={image} alt={alt} />
      ) : (
        <span tabIndex={-1} className={styles.titleContainer}>{oneLetterAcronym ? getNameFirstLetter(title) : Helper.generateShortName(title)}</span>
      )}
      {children}
    </div>
  );
};

export default Avatar;
